import { Button, EButtonColorVariant, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React, { useEffect } from 'react';

import { trackPromoBannerClicked, trackPromoBannerViewed } from '@/services/analytics/promo';

type TAdvertisementTileV2Props = {
  heading: string | React.JSX.Element | (string | React.JSX.Element)[];
  linkLabel: string;
  image: string;
  href: string;
  target?: string;
  odn_id?: string;
  gradient?: boolean;
};

export const AdvertisementTileV2 = ({
  heading,
  linkLabel,
  image,
  href,
  target,
  odn_id,
  gradient,
}: TAdvertisementTileV2Props) => {
  const bannerText = heading.toString();
  const handleCLick = () => {
    trackPromoBannerClicked({
      bannerText: bannerText,
      bannerCTA: linkLabel,
      bannerLink: null,
      bannerName: 'outdoorsyStaysDeliveryMVP',
      source: 'search',
      odn_id,
    });
  };

  useEffect(() => {
    trackPromoBannerViewed({
      bannerText: bannerText,
      bannerCTA: linkLabel,
      bannerLink: null,
      bannerName: 'outdoorsyStaysDeliveryMVP',
      source: 'search',
      odn_id,
    });
  }, [bannerText, heading, linkLabel, odn_id]);

  return (
    <li className="relative">
      <div>
        <Image
          className="rounded-2xl"
          src={image}
          alt="Outdoorsy Stays advertisement image"
          role="presentation"
          layout="fill"
          objectFit="cover"
          width={0}
          height={0}
          style={{ width: '100%', height: '100%' }}
        />
        {gradient && (
          <div className="absolute inset-0 bg-gradient-to-b from-[#1f1f1f68] to-transparent rounded-2xl" />
        )}
      </div>
      <div className="flex flex-col items-center justify-between h-full p-6 text-center text-white gap-y-2 min-h-[19rem] md:min-h-auto">
        <div className="z-10">
          {heading && <Text className="z-10 pt-5 text-lg font-medium">{heading}</Text>}
        </div>
        <Button
          onClick={handleCLick}
          label={linkLabel}
          variant={EButtonColorVariant.Tertiary}
          onDark
          href={href}
          target={target}
        />
      </div>
    </li>
  );
};
